<template>
    <!-- Root de l’item (clé pour l’alternance et le surlignage) -->
    <div class="fi-item block w-full odd:bg-white even:bg-[#F7F9FC]" :id="fibsdd.id"
        :class="(fibsdd.affectation_user === idUser) ? 'border-l-[6px] border-solid border-[#0C2A5C]' : ''">

        <router-link :to="linkFi" class="block w-full p-4 flex items-center gap-4">
            <!-- Zone texte -->
            <div class="flex-1 min-w-0">
                <!-- Ligne titre -->
                <div class="flex items-start flex-wrap gap-2">
                    <h2>
                        <span class="inline-flex flex-col items-start gap-1">

                            <!-- Ligne “Fiche affectée” au-dessus du numéro -->
                            <template v-if="fibsdd.affectation_user === idUser">
                                <span class="inline-flex items-center gap-2 text-secondary italic text-sm">
                                    <div class="bg-secondary rounded-full h-5 w-5 flex-shrink-0 grid place-items-center">
                                        <i class="inline-block h-4 w-4 mask mask-user bg-white"></i>
                                    </div>
                                    Fiche affectée
                                </span>
                            </template>

                            <!-- Ligne numéro + ordre de travail -->
                            <span class="flex items-center gap-2">
                                <span class="font-bold text-xl text-bleu-moyen uppercase">
                                    {{ fibsdd.numero }}
                                </span>

                                <p v-if="fibsdd.ordre_travail != null"
                                class="text-md text-secondary">
                                    - {{ fibsdd.ordre_travail }}
                                </p>
                            </span>

                        </span>
                    </h2>
                </div>


                <!-- Détenteur -->
                <p class="text-sm text-gris">
                    <template v-if="detenteur">
                        {{ detenteur.raison_sociale }} - {{ detenteur.adresse }}<br class="hidden sm:block" />
                        {{ detenteur.code_postal }} - {{ detenteur.ville }}
                    </template>
                    <template v-else>
                        Chargement en cours...
                    </template>
                </p>

                <!-- Installation -->
                <p v-if="installation" class="text-md text-secondary font-bold">
                    {{ installation.nom }}
                </p>
            </div>

            <!-- Chevron -->
            <div class="bg-primary rounded-full h-9 w-9 flex-shrink-0 grid place-items-center">
                <i class="inline-block h-6 w-6 mask mask-arrow-left bg-white rotate-180"></i>
            </div>

            <!-- Poubelle si supprimable -->
            <button v-show="fibsdd.supprimable === true"
                class="bg-red-500 rounded-full h-9 w-9 flex-shrink-0 grid place-items-center"
                @click.stop.prevent="delFi(fibsdd.id)" type="button" aria-label="Supprimer">
                <i class="inline-block h-6 w-6 mask mask-trash bg-white"></i>
            </button>
        </router-link>
    </div>
</template>

<script>
import Detenteur from '../../../js/models/Detenteur'
import Installation from '../../../js/models/Installation'
import Fibsdd from '../../../js/models/Fibsdd'

export default {
    props: {
        fibsdd: Object,
        detenteur: Object,
        installation: Object,
        idUser: Number
    },
    computed: {

        linkFi() {
            if (this.detenteur != null) {
                return 'fibsdd/' + this.fibsdd.id
            } else {
                return '#';
            }
        },

    },
    methods: {

        delFi(id) {

            swal({
                title: 'Suppression de fibsdd',
                text: "Voulez vous vraiment supprimer cette fiche ?",
                type: 'question',
                showCancelButton: true,
                cancelButtonText: 'Non',
                confirmButtonText: 'Oui'
            }).then(

                () => {

                    Fibsdd.delFibsdd(id).then(() => {
                        swal('Fibsdd supprimée', '', 'info', { allowOutsideClick: false }).then(
                            //remove div with id
                            () => {
                                let div = document.getElementById(id);
                                div.parentNode.removeChild(div);
                            }
                        )
                    })
                },
            )
        }
    },

    async mounted() {

    }
}
</script>


// WEBPACK FOOTER //
// FibsddItem.vue?648934c9